<template>
  <div class="footer_div">
  <footer>
    <div class="main_text_box">
      <h3><span id="thehae">더해</span>와 함께해요. <span class="more" onclick="location_notice();"><img src="images/basic/icon/main-more-b.svg" alt=""></span></h3>
      <h2>{{ tel }}</h2>
      <p>운영시간: {{ operTime }}</p>
    </div>
    <sns-logo-list></sns-logo-list>
    <div class="notice_div">
      <table>
        <tr v-for="notice in noticeList" :key="notice.nttId" @click="goToDetailPage(notice)">
          <th>{{  notice.boardNm }}</th>
          <td>{{  notice.nttSj }}</td>
        </tr>
      </table>
    </div>
    <div class="background_color"></div>
    <div class="footer_info">
      <div class="policy">
        <a v-for="info in termsList" :key="info.nttId" @click.prevent="goToTermsDetail(info.nttId)">{{ info.nttSj }}</a>
      </div>
      <div class="address_div">
        <!-- <span>대표이사: 신민하 | 사업자등록번호: 143-12-132335<br>
          통신판매업: 서울-강남-0123 | 이메일: cs@thehae.com<br>
          고객센터: 070-8280-0310(월~금 09:30 ~ 18:30)<br>
          주소: 서울특별시 강남구 역삼로 147, 3층 304-1호<br>
          호스팅서비스제공자: (주)후이즈
        </span> -->
      </div>
    </div>
  </footer>
</div>
</template>

<script>
import SnsLogoList from '@/components/common/SnsLogoList.vue'
export default {
  components: {
    SnsLogoList
  },
  props: {
    noticeList: {
      type: Array,
      required: true,
    },
    tel: {
      type: String,
      required: true,
    },
    operTime: {
      type: String,
      required: true,
    },
    termsList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    goToTermsDetail(nttId) {
      this.$router.push({
        path: '/termsDetail', query: {
          nttId
        }
      })
    },
    goToDetailPage(list) {
     if(list.linkType == "noticeDetail") {
          this.$router.push({
              path: '/noticeDetail',
              query: { nttId: list.nttId }
          })
     }
     if(list.linkType == "boardDetail") {
          this.$router.push({
              path: '/community_view',
              query: { boardId: list.boardId, nttId: list.nttId }
          })
     }
     if(list.linkType == "eventDetail") {
         if(list.status == 'ING') {
           this.$router.push({
               path: '/ongoingEvent',
               query: { nttId: list.nttId }
           })
         }
         if(list.status == 'READY') {
           this.$router.push({
               path: '/upcomingEvent',
               query: { nttId: list.nttId }
           })
         }
         if(list.status == 'END') {
           this.$router.push({
               path: '/endedEvent',
               query: { nttId: list.nttId }
           })
         }
     }
     if(list.linkType == "link") {
          this.$router.push(`/${list.linkUrl}`)
     }
   }
  },

}
</script>

<style>

</style>